import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { WeaTimePicker } from 'ecCom';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import _ from 'lodash';

@observer
export default class TimePicker extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const { isdetail } = card.getFieldProps(path);
        const bind = bindObj.bind();
        const {quickEditStore,getDetailFormValues} = card;
        const { format } = cell;
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bind;

        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }
        let formatPattern = "3";  //默认： HH:MI
        if (format) {//日期字段单元格格式 直接通过字段参数实现
            let numberType = format.numberType;
            if (numberType == "4") {
                formatPattern = format.formatPattern ? format.formatPattern : "3";
            }
        }
        let layoutProps = {};
        if (!isdetail) {
            layoutProps = {
                layout: document.getElementById("time"+fieldName),
                useSelfLayout: true
            }
        }
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
        if(!canQuickedit){
            isDisplay = 'none';
        }
        let value = "" || _.trim(bind.value);
        //#997381概述：解决了点击添加明细，页面异常的问题
        if (typeof (value) == 'string' && value.indexOf('doFieldDate') > -1) {
            value = ""
          }
        return (
            <div id={"time"+fieldName} className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps}
            onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaTimePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaTimePicker@jl3pl2`}
                    {...bind}
                    value={value}
                    fieldName={fieldName}
                    noInput={true}
                    viewAttr={viewAttr}
                    formatPattern={formatPattern}
                    {...layoutProps}
                />
                <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/browser-element/TimePicker.tsx